<template>
  <div class="mega-menu bg-white radius-medium pd-medium">
    <div class="mega-menu__grid">
      <section
        v-for="category in categories"
        :key="category.title"
        class="flex flex-column gap-thin"
      >
        <h6 class="uppercase fw-medium opacity-50 p-small mn-b-thin">{{ category.title }}</h6>

        <template v-for="item in category.items" :key="item.title">
          <a
            v-if="item.external"
            :href="item.href"
            target="_blank"
            rel="noopener noreferrer"
            class="mega-menu__item flex flex-v-center gap-thin pd-small radius-small fw-medium hover:bg-light"
          >
            <Icon
              v-if="item.icon"
              :name="item.icon"
              class="mega-menu__icon i-medium t-black-transp-50"
            />
            <span class="mn-r-auto">{{ item.title }}</span>
            <span class="mega-menu__external" aria-hidden="true">↗</span>
          </a>

          <!-- Без route — раздел ещё не запущен: «Скоро», не ведём никуда -->
          <span
            v-else-if="!item.route"
            class="mega-menu__item mega-menu__item--soon flex flex-v-center gap-thin pd-small radius-small fw-medium"
            aria-disabled="true"
          >
            <Icon
              v-if="item.icon"
              :name="item.icon"
              class="mega-menu__icon i-medium t-black-transp-50"
            />
            <span>{{ item.title }}</span>
            <span v-if="item.badge" class="mega-menu__chip">{{ item.badge }}</span>
          </span>

          <router-link
            v-else
            :to="item.route"
            class="mega-menu__item flex flex-v-center gap-thin pd-small radius-small fw-medium hover:bg-light"
          >
            <Icon
              v-if="item.icon"
              :name="item.icon"
              class="mega-menu__icon i-medium t-black-transp-50"
            />
            <span>{{ item.title }}</span>
            <span v-if="item.badge" class="mega-menu__chip">{{ item.badge }}</span>
          </router-link>
        </template>
      </section>
    </div>
  </div>
</template>

<script setup>
import Icon from '@martyrs/src/design-system/components/Icon/Icon.vue';

// Данные мега-меню инкапсулированы внутри компонента: Navigation прокидывает
// только сам компонент (`item.dropdownComponent`), без пропсов.
const categories = [
  {
    title: 'Инструменты',
    items: [
      { title: 'Аудит аккаунтов',          icon: 'resume',       route: '/tools/audit' },
      { title: 'Шаблоны инвайтов',         icon: 'applications', route: '/tools/templates' },
      { title: 'Сценарии задач',           icon: 'interview',    route: '/tools/scripts' },
      { title: 'Каналы и чаты',            icon: 'searches',     route: '/tools/channels', badge: 'Скоро' },
    ],
  },
  {
    title: 'О сервисе',
    items: [
      { title: 'О нас',            route: '/about' },
      { title: 'Вопросы и ответы', route: '/faq' },
      { title: 'Оферта',           route: '/legal/offer' },
      { title: 'Новости и статьи', route: '/community' },
    ],
  },
  {
    title: 'Поддержка',
    items: [
      // Telegram канал — бренд-канал. Telegram поддержка — отдельный support-handle.
      { title: 'Telegram канал',     external: true, href: 'https://t.me/traffers' },
      { title: 'Telegram поддержка', external: true, href: 'https://t.me/traffers_support' },
      { title: 'Полезные ссылки',    route: '/links' },
      { title: 'Партнерам',          route: '/partners', badge: 'Скоро' },
    ],
  },
];
</script>

<style scoped>
.mega-menu {
  min-width: 0;
  max-width: 64rem;
  box-shadow: var(--elevation-3);
}

/* Desktop (≥768px) — 3 колонки, фикс-ширина для хедер-дропдауна.
   Mobile — 1 колонка, ширину диктует контейнер (сайдбар). */
.mega-menu__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--small);
}

@media (min-width: 768px) {
  .mega-menu {
    min-width: 48rem;
  }
  .mega-menu__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: var(--regular);
  }
}

.mega-menu__item {
  text-decoration: none;
  color: inherit;
}

/* «Скоро» — визуально приглушён, не кликается. */
.mega-menu__item--soon {
  opacity: 0.55;
  cursor: default;
}

.mega-menu__icon {
  flex-shrink: 0;
}

/* Чип-бейдж «Скоро»/«Новое» на theme-токенах — мягкий main-tint,
   не агрессивный солид. */
.mega-menu__chip {
  margin-left: var(--thin);
  padding: 2px var(--thin);
  border-radius: var(--radius-pill);
  background: rgba(var(--main), 0.12);
  color: rgb(var(--main));
  font-size: var(--fs-micro);
  font-weight: 600;
}

.mega-menu__external {
  margin-left: var(--thin);
  color: rgb(var(--grey));
  font-size: var(--fs-small);
}
</style>
